import {
  ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output,
} from '@angular/core';

@Component({
  selector: 'app-suchtyp-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './suchtyp-modal.component.html',
  styleUrl: './suchtyp-modal.component.scss',
})
export class SuchtypModalComponent {
  /** Optional context line in the modal header — Gewerk label. */
  @Input() gewerkLabel: string | null = null;
  /** Optional context line — PLZ / Ort. */
  @Input() ortLabel: string | null = null;

  @Output() guidedSelected = new EventEmitter<void>();
  @Output() selfSelected = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closed.emit();
    }
  }
}
